import { PortalRefusal } from "@/data/api/client";
import type { Business } from "@/domain/business/types";

export interface SitePayload {
  id: number;
  name: string | null;
  street: string | null;
  city: string | null;
  zip: string | null;
  latitude: number | null;
  longitude: number | null;
}

export interface BusinessPayload {
  id: number;
  name: string;
  phone: string | null;
  notificationEmail: string | null;
  discountUsesPerCustomer: number | null;
  discountUsesPeriodDays: number | null;
  sites?: SitePayload[];
}

/** The address and the map pin are a site's, not the business's. The portal
 *  edits one place per business — the default site the database creates with it,
 *  which is the oldest and so the first the API answers with. A business the API
 *  answers with no site for is one the portal could only pretend to save, so it
 *  stops here rather than on a save that reports success and writes nothing. */
export function payloadToBusiness(payload: BusinessPayload): Business {
  const defaultSite = payload.sites?.[0];
  if (defaultSite === undefined) {
    throw new PortalRefusal(
      "Údaje podniku se nepodařilo načíst — chybí místo, kam patří jeho adresa. Ozvěte se nám prosím.",
    );
  }
  return {
    id: payload.id,
    name: payload.name,
    defaultSiteId: defaultSite.id,
    addressStreet: defaultSite.street,
    addressCity: defaultSite.city,
    addressCode: defaultSite.zip,
    locationLatitude: defaultSite.latitude,
    locationLongitude: defaultSite.longitude,
    phone: payload.phone,
    notificationEmail: payload.notificationEmail,
    discountUsesPerCustomer: payload.discountUsesPerCustomer,
    discountUsesPeriodDays: payload.discountUsesPeriodDays,
  };
}
